// Generated by purs version 0.14.3
"use strict";
var Control_Bind = require("../Control.Bind/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Network_Ethereum_Core_HexString = require("../Network.Ethereum.Core.HexString/index.js");
var Network_Ethereum_Core_Signatures = require("../Network.Ethereum.Core.Signatures/index.js");
var srAddress = Data_Maybe.fromJust()(Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(Network_Ethereum_Core_Signatures.mkAddress)(Network_Ethereum_Core_HexString.mkHexString("41a322b28d0ff354040e2cbc676f0320d8c8850d")));
module.exports = {
    srAddress: srAddress
};
